(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-manager/assets/javascripts/draw-manager-modal.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-manager/assets/javascripts/draw-manager-modal.js');
"use strict";


const {
  StickyBottom,
  StickyButtonClose,
  TipsenModal
} = svs.components.tipsen.tipsenModal;
const {
  DrawSelectorList
} = svs.components.tipsen.drawSelector;
const Paper = svs.ui.ReactPaper;
const DrawSelectorListStickyBottom = _ref => {
  let {
    onClose
  } = _ref;
  return React.createElement(StickyBottom, null, React.createElement(StickyButtonClose, {
    onClick: e => {
      onClose(e);
    }
  }));
};
const DrawManagerModal = _ref2 => {
  let {
    isOpen,
    toggleDrawSelector,
    composedDraws,
    currentDrawNumber,
    productBranding,
    showBetEventsByDraw,
    toggleBetEventsFunc
  } = _ref2;
  const drawSelectorListStickyBottom = () => React.createElement(DrawSelectorListStickyBottom, {
    onClose: toggleDrawSelector
  });
  return React.createElement(TipsenModal, {
    Bottom: drawSelectorListStickyBottom,
    className: "tipsen-modal-window",
    isOpen: isOpen
  }, React.createElement("div", {
    className: "pg_draw_manager__modal_container"
  }, React.createElement(Paper, {
    branding: "sport"
  }, React.createElement(DrawSelectorList, {
    branding: productBranding,
    draws: composedDraws,
    onToggleFunc: toggleDrawSelector,
    selectedDrawNumber: currentDrawNumber,
    showBetEventsByDraw: showBetEventsByDraw,
    toggleBetEventsFunc: toggleBetEventsFunc
  }))));
};
setGlobal('svs.components.tipsen.drawManager.DrawManagerModal', DrawManagerModal);

 })(window);